import type { ReactNode } from 'react';

interface LoadingNoteGenerationProps {
  messages?: ReactNode[];
  loadingComponent?: ReactNode;
}

export const LoadingNoteGeneration = ({
  messages,
  loadingComponent,
}: LoadingNoteGenerationProps) => {
  // If a custom loading component is provided, use it
  if (loadingComponent) {
    return <>{loadingComponent}</>;
  }

  // Otherwise, render a simple loading state
  const defaultMessages = messages || [
    'Generating Audio Transcript...',
    'Generating Summary...',
    'Generating Clinical Note...',
  ];

  return (
    <>
      <div className="vai-flex vai-flex-col vai-items-center">
        <div className="vai-animate-spin vai-rounded-full vai-h-12 vai-w-12 vai-border-b-2 vai-border-gray-900"></div>
        <div className="vai-mt-4 vai-text-center">
          {Array.isArray(defaultMessages) && defaultMessages.length > 0 && (
            <p className="vai-text-sm vai-text-gray-600">
              {defaultMessages[0]}
            </p>
          )}
        </div>
      </div>
    </>
  );
};
